import { css } from '@emotion/css';

export const h256 = css`
  height: 256px;
`;

export const h187 = css`
  height: 187px;
`;

export const imageStyles = css`
  border-color: rgba(255, 255, 255, 0.3);
`;

export const s3 = css`
  width: 0.3rem;
  height: 0.3rem;
`;

export const maxW280 = css`
  max-width: 28rem;
`;

export const mentionColors = (textColor: string, bgColor: string) => css`
  a[data-mention-type='USER'] {
    color: ${textColor} !important;
    background-color: transparent !important;
    font-weight: var(--fw-label-02);
    font-family: var(--ff-label-02);
    font-size: var(--fs-label-02);
    line-height: var(--lh-label-02);
    letter-spacing: var(--ls-label-02);
    padding: 2px;
  }
`;

export const linkColor = (textColor: string) => css`
  a[class*='link-element'] {
    color: ${textColor};
  }
`;

export const videoBackgroundStyles = css`
  background-color: rgba(255, 255, 255, 0.9);
`;

export const reactionHoverStyles = css`
  :hover {
    background-color: var(--interactive-blur-hover) !important;
  }
`;
